export enum AuthorityType {
  TAX_AUTHORITY = 'tax_authority',
  MUNICIPALITY = 'municipality',
  ISRAEL_LAND_AUTHORITY = 'israel_land_authority'
}

export interface AuthorityCatalogEntry {
  code: AuthorityType;
  sortOrder: number;
}

/**
 * Closed list of authorities money can be paid out to. Display copy is NOT stored here or
 * in the DB — the frontend looks it up via i18n (`authorities.<code>`), same as `Permission`.
 */
export const AUTHORITY_CATALOG: readonly AuthorityCatalogEntry[] = [
  {code: AuthorityType.TAX_AUTHORITY, sortOrder: 1},
  {code: AuthorityType.MUNICIPALITY, sortOrder: 2},
  {code: AuthorityType.ISRAEL_LAND_AUTHORITY, sortOrder: 3}
] as const;
